<template>
  <div> 
	<CCardHeader>
	<CButton color="primary" class="px-4" @click="add()">Add Statuses</CButton>	
	</CCardHeader>
    <CRow>
      <CCol sm="12">
        <CTableWrapper
          :items="getShuffledUsersData()"
          hover
          striped
          bordered
          small
          fixed
          caption="User list"
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import CTableWrapper from './Statuses_master.vue'
import usersData from '../all_masters/UsersData'

export default {
  name: 'Statuses_masters',
  components: { CTableWrapper },
  methods: {
    shuffleArray (array) {
      for (let i = array.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1))
        let temp = array[i]
        array[i] = array[j]
        array[j] = temp
      }
      return array
    },

    getShuffledUsersData () {
      return this.shuffleArray(usersData.slice(0))
    },
	add(){
		console.log('add');
		this.$router.push({path:'add_statuses'})
	}
  }
}
</script>
